import StatsService from '../../services/StatsService';

export default {
  namespaced: true,
  actions: {
    // eslint-disable-next-line no-unused-vars
    sendLog({state, rootState}, log) {
      // console.log('log', log);
      StatsService.sendStat(log.action, log.description, log.meta || {}, rootState.isElectron);

      if (window.flutter_inappwebview) {
        const handler = window.flutter_inappwebview.callHandler || window.flutter_inappwebview._callHandler;
        if (typeof handler === 'function') {
          handler("logHandler", log)
        }
      }
    }
  }
};
